module.exports = __webpack_public_path__ + "img/zimi-thumbnails.6a1b89f5.png";